// تتبع إحصاءات خفيف بلا أي بيانات شخصية — حدث + مفتاح فقط، مرة واحدة لكل جلسة لكل حدث/مفتاح
import { api } from "@/lib/api";

export const track = (event, key = "") => {
  try {
    const k = `tg_trk_${event}_${key}`;
    if (sessionStorage.getItem(k)) return;
    sessionStorage.setItem(k, "1");
    api.post("/analytics/event", { event, key }).catch(() => {});
  } catch { /* no-op */ }
};
